import React from 'react';

import styles from './styles.module.css';

const Input = ({ type = 'text', name, value, onChange, placeholder, scale = 'medium' }) => {
  return (
    <input
      className={`${styles.input} ${styles[scale]}`}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default Input;
